import React, {useEffect, useState} from "react";
import SelectDepartment from "./SelectDepartment";
import CustomInputSearch from "../../components/general/CustomInputSearch";
import useInputValue from "../../hooks/useInputValue";
import CustomDatePicket from "../../components/general/CustomDatePicket";
import {useTranslation} from "react-i18next";
import CustomButton from "../../components/general/CustomButton";
import {UserDepartmentInterface} from "../../services/interface/UserDepartmentInterface";
import {CustomPagination} from "../../components/general/pagination/CustomPagination";
import DialogCreateProcess from "./DialogCreateProcess";
import {useFindAllProcess} from "../../services/process/apiProcess";
import {SIZE_PAGINATION} from "../../conf";
import {PageProcessInterface, ProcessDto} from "../../services/interface/ProcessDtoInterface";
import ListProcess from "./ListProcess";
import * as Icons from "@mui/icons-material";
import {useProcessStore} from "../../services/storage/process/ProcessStorage";

export default function Process() {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const {mutate: findAllProcess, isPending: isLoading, data: successFindProcess} = useFindAllProcess()
    const processStorage = useProcessStore(data => data.data)
    const setProcessStorage = useProcessStore(data => data.setData)

    const [department, setDepartment] = React.useState<UserDepartmentInterface>();
    const search = useInputValue('')
    const [searchValue, setSearchValue] = useState<string | undefined>()
    const [dateInit, setDateInit] = useState<Date | undefined>()
    const [dateEnd, setDateEnd] = useState<Date | undefined>()

    const [open, setOpen] = React.useState<boolean>(false)
    const [index, setIndex] = React.useState<number | undefined>(0)
    const [listProcess, setListProcess] = useState<PageProcessInterface | undefined>()
    const [title, setTitle] = React.useState<string>(t('create-process'))
    const [processDB, setProcessDB] = React.useState<ProcessDto | undefined>()

    useEffect(() => {
        if ((index || index === 0) && department && department.idDepartment) {
            setListProcess(undefined)
            findAllProcess({
                department: department.idDepartment,
                filter: searchValue,
                dateInit,
                dateEnd,
                page: index,
                size: SIZE_PAGINATION
            })
        }
    }, [index, searchValue, department, dateInit, dateEnd]);

    useEffect(() => {
        if (processStorage && !open && department) {
            setProcessStorage(null)
            setListProcess(undefined)
            findAllProcess({
                department: department.idDepartment,
                filter: searchValue,
                dateInit,
                dateEnd,
                page: index,
                size: SIZE_PAGINATION
            })
        }
    }, [processStorage, open]);

    useEffect(() => {
        if (successFindProcess) {
            setListProcess(successFindProcess)
        }
    }, [successFindProcess]);

    return (
        <>
            {open && <DialogCreateProcess {...{title, processDB, department, open, setOpen}}/>}
            <div className={'w-full h-full py-2 flex flex-col sm:flex-row gap-5'}>
                <SelectDepartment {...{department, setDepartment}} />
                <div className={'w-full flex flex-col gap-5'}>
                    <div className={'flex flex-col sm:flex-row gap-5 min-h-[20px] sm:items-center'}>
                        <h2>{department?.department}</h2>
                        <CustomButton
                            className={'ml-auto bg-primary'}
                            text={t('create-process')}
                            onClick={() => {
                                setTitle(t('create-process'))
                                setProcessDB(undefined)
                                setOpen(true)
                            }}
                        />
                    </div>
                    <div className={'flex flex-col sm:flex-row gap-5'}>
                        <CustomInputSearch
                            onClick={() => {
                                setSearchValue(search.value)
                            }}
                            {...search}
                        />
                        <CustomDatePicket
                            label={t('date-init')}
                            value={dateInit}
                            setValue={setDateInit}
                        />
                        <CustomDatePicket
                            label={t('date-end')}
                            value={dateEnd}
                            setValue={setDateEnd}
                        />
                        <Icons.Cancel className={'ml-auto mt-2 text-primary'} onClick={() => {
                            search.onChangeText('')
                            setIndex(0)
                            setDateInit(undefined)
                            setDateEnd(undefined)
                            setSearchValue(undefined)
                        }}/>
                    </div>
                    <ListProcess loading={isLoading} {...{listProcess, setListProcess, setProcessDB, setOpen, setTitle}}/>
                    <CustomPagination
                        loading={isLoading}
                        currentPage={listProcess?.number}
                        totalElements={listProcess?.totalElements}
                        totalPages={listProcess?.totalPages}
                        {...{setIndex}}
                    />
                </div>
            </div>
        </>
    )
}
